// extracted by mini-css-extract-plugin
export default {"SignInSignUpLogo":"SiderContentC_SignInSignUpLogo__1vrbx","Menu":"SiderContentC_Menu__+CHJM"};